import CartNavigation from "../navigation/CartNavigation";
import CartProduct from "./CartProduct.js";
import CartNoProducts from "./CartNoProducts.js";
import CustomerDetailsModal from "../customer-details-modal/CustomerDetailsModal.js";
import ErrorAlert from "../../../common/ui/ErrorAlert.js";
import ErrorModal from "../../../common/ui/ErrorModal.js";
import OfflineModal from "../../../common/ui/OfflineModal.js";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import * as CommonUtilities from "../../../common/utils/CommonUtils.js";
import moment from "moment";
import {ReactComponent as S8PoweredByLogo} from "../../../images/S8PoweredLogo_Black.svg"; 
import Messages from "../../../common/ui/Messages.js";
// Pick-up day/time scheduler — replaces react-datepicker. The library and its
// stylesheet are no longer imported here; PickupScheduler is plain markup.
import PickupScheduler from "./PickupScheduler.js";
// Trimmed to what is actually used: getDay, in isOpenDay below. The other six
// (getYear, getMonth, addDays, subDays, setHours, setMinutes) were only ever
// used by the datepicker's minDate/maxDate and went with it.
import { getDay } from "date-fns";

export default function CartPage(props) {
    const pickupTimeOptions = [...Array(13)].map((item, index) => <option key={index * 5} value={index * 5}>{index === 0 ? 'ASAP' : index * 5 + ' mins' }</option>);
    const isWebOrder = props.urlConfig.Type === '' || props.urlConfig.Type === null || props.urlConfig.Type === 'null' || props.urlConfig.Type === 'web' ? true : false;

    // === Check Loading / Render Product & Total Price ===
    let totalPrice, products, subTotal, webProcessingFee, deliveryAndServiceFee, subTotalBottomPadding, voucher, productsInVoucher;
    let voucherSummaryRow = <></>;
    let hasVoucher = false;
    let originalProductPriceVoucher = 0;
    let discountedProductPriceVoucher = 0;
    if (props.cartDetails.cartIsLoading) {
        // Loading
        products = 
            <div className="col-12 row p-0 m-0">
                <div className="col-sm-8 col-6 d-flex align-items-start gap-2 gap-sm-3">
                    <div className="col-sm-1 col-2 rounded-pill placeholder placeholder-wave bg-secondary" style={{height: "30px"}}></div>
                    <div className="d-flex flex-column justify-content-start col-sm-8 col-10 row ps-2">
                        <div className="placeholder placeholder-wave bg-secondary col-sm-4 col-8" style={{height: "20px"}}></div>
                        <div className="placeholder placeholder-wave bg-secondary col-sm-3 col-4 mt-2" style={{height: "10px"}}></div>
                    </div>
                </div>
                <div className="col-sm-4 col-6 text-end">
                    <div className="d-flex flex-column align-items-end">
                        <div className="placeholder placeholder-wave bg-secondary col-sm-4 col-6" style={{height: "20px"}}></div>
                        <div className="placeholder placeholder-wave bg-secondary col-sm-3 col-4 mt-2" style={{height: "10px"}}></div>
                    </div>
                </div>
                <div className="col-12 pt-1">
                    <hr className="text-body-tertiary" />
                </div>
            </div>
        totalPrice = <Spinner animation="border" role="status" variant="secondary" size="sm" className="ms-2 mb-n3" style={{height: "25px", width: "25px"}}></Spinner>;
        subTotal = <></>;
        webProcessingFee = <></>;
        deliveryAndServiceFee = <></>;
        subTotalBottomPadding = <></>;
    } else if (!props.cartDetails.cartIsLoading) {

        // Products
        if (props?.cartDetails?.cartDetails?.products?.length > 0 || props?.cartDetails?.cartDetails?.saleDiscountDetails != undefined && props?.cartDetails?.cartDetails?.saleDiscountDetails != null) {
            products = props.cartDetails.cartDetails.products.map((item) => {
                return (
                    <CartProduct 
                        key={item.recID}
                        data={item}
                        cartError={props.cartError}
                        handleQuantityChange={props.handleQuantityChange}
                        handleRemoveProdFromCart={props.handleRemoveProdFromCart}
                    />
                )
            })
        } else {
            products = <CartNoProducts orderPayBody={props.orderPayBody} />
        }

        // Voucher
        if (props?.cartDetails?.cartDetails?.saleDiscountDetails !== '' && props?.cartDetails?.cartDetails?.saleDiscountDetails !== null && props?.cartDetails?.cartDetails?.saleDiscountDetails !== undefined ) {
            let voucherDetails = props.cartDetails.cartDetails.saleDiscountDetails;
            productsInVoucher = voucherDetails?.cartUserTempAddedDiscountsProducts?.map((product) => {
                originalProductPriceVoucher += product.originalPrice;
                discountedProductPriceVoucher += product.priceInc;
                // Modifiers in each product in Voucher
                let modsInProduct;
                if (product?.cartUserTempAddedDiscountsModsList?.length > 0) {
                    let mods = product.cartUserTempAddedDiscountsModsList.map((mod) => {
                        discountedProductPriceVoucher += mod.priceInc;
                        let modPrice = CommonUtilities.formatDisplayPrice(mod.priceInc);
                        return <li key={mod.cartUserTempAddedDiscountsModsID}>{mod.productName}<span className="ms-2 ps-1">{modPrice}</span></li>
                    })
                    modsInProduct = 
                        <small className="text-muted">
                            <ul>
                                {mods}
                            </ul>
                        </small>
                } else {
                    modsInProduct = <></>
                }
                // Products in Voucher
                return (<div className="col-12 text-secondary" key={voucherDetails.cartUserTempAddedDiscountsProductsID}>
                            {product.productName}{modsInProduct}
                        </div>)
            })
            voucher =   <div className="col-12 row p-0 m-0" key={voucherDetails.cartUserTempAddedDiscountsID}>
                            <div className="col-8 d-flex align-items-start gap-2 gap-sm-3">
                                <div style={{width: "65px", height: "31px"}} className="rounded-pill bg-light border ps-2 d-flex align-items-center">
                                    <span key="1" style={{fontSize: "0.9rem"}}>1</span>
                                </div>
                                <div className="d-flex flex-column justify-content-start text-break">
                                    <b>{voucherDetails.loyaltyProductNameExternal}</b>
                                    {productsInVoucher}
                                </div>
                            </div>
                            <div className="col-4 text-end">
                                <div className="d-flex flex-sm-row flex-column justify-content-sm-end justify-content-start align-items-sm-start align-items-end">
                                    <span className="text-muted order-2 order-sm-1"><s>{CommonUtilities.StaticFields.CurrencySymbol}{(originalProductPriceVoucher).toFixed(2)}</s></span>
                                    <span className="ps-3 fw-bold order-1 order-sm-2">{CommonUtilities.StaticFields.CurrencySymbol}{(discountedProductPriceVoucher).toFixed(2)}</span>
                                </div>
                                <div>
                                    <a className="link-primary link-underline link-underline-opacity-0 link-offset-2 link-underline-opacity-50-hover" href="#" onClick={props.handleRemoveVoucherFromCart} data-addeddiscountid={voucherDetails.cartUserTempAddedDiscountsID}>Remove</a>
                                </div>
                            </div>
                            <div className="col-12">
                                <hr className="text-body-tertiary" />
                            </div>
                        </div>
            hasVoucher = true;

            /* 2026-10-14 A SALE voucher (dollar or percentage off the whole order -
               what a typed voucher code is) has no discounted products, so the block
               above would print a struck-through $0.00 and $0.00. Show its name and
               the saving instead. The amount is the server's: CartCalculator stores
               it negative once applied. Item vouchers keep the block above. */
            if (String(voucherDetails.productType || '').toLowerCase() === 'sale') {
                const saving = Math.abs(Number(voucherDetails.discountAmount) || 0);
                const savingText = `−${CommonUtilities.StaticFields.CurrencySymbol}${saving.toFixed(2)}`;
                voucher =   <div className="col-12 row p-0 m-0 wo-vline" key={voucherDetails.cartUserTempAddedDiscountsID}>
                                <div className="col-8 d-flex align-items-start gap-2 gap-sm-3">
                                    <div className="d-flex flex-column justify-content-start text-break">
                                        <span className="wo-vline__tag">{Messages.VoucherLabel}</span>
                                        <b>{voucherDetails.loyaltyProductNameExternal}</b>
                                    </div>
                                </div>
                                <div className="col-4 text-end">
                                    <span className="fw-bold wo-vline__amount">{savingText}</span>
                                    <div>
                                        <button type="button" className="btn btn-link p-0 border-0 align-baseline link-primary link-underline link-underline-opacity-0 link-offset-2 link-underline-opacity-50-hover" onClick={props.handleRemoveVoucherFromCart} data-addeddiscountid={voucherDetails.cartUserTempAddedDiscountsID}>Remove</button>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <hr className="text-body-tertiary" />
                                </div>
                            </div>
                voucherSummaryRow =
                    <div className="wo-sum__row wo-sum__row--voucher">
                        <span>{Messages.VoucherLabel}</span>
                        <span>{savingText}</span>
                    </div>
            }
        } else {
            voucher = <></>
        }

        // Total Price
        if (props?.cartDetails?.cartDetails?.totalInc) {
            totalPrice = `${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.totalInc).toFixed(2)}`;
        } else {
            totalPrice = `${CommonUtilities.StaticFields.CurrencySymbol}${(0).toFixed(2)}`;
        }

        // Calculate Subtotal via Fees
        let serviceFeeWebOrderingValue, storeServiceFeeValue;

        // Service Fee - Web Ordering 
        if (props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== 0 && props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== '' && props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== null && props?.cartDetails?.cartDetails?.serviceFeeWebOrdering !== undefined) {
            serviceFeeWebOrderingValue = props.cartDetails.cartDetails.serviceFeeWebOrdering;
        } else {
            serviceFeeWebOrderingValue = 0;
        }
        
        // Delivery + Store Fee - Web Ordering 
        if (props?.cartDetails?.cartDetails?.storeServiceFee !== 0 && props?.cartDetails?.cartDetails?.storeServiceFee !== '' && props?.cartDetails?.cartDetails?.storeServiceFee !== null && props?.cartDetails?.cartDetails?.storeServiceFee !== undefined) {
            storeServiceFeeValue = props.cartDetails.cartDetails.storeServiceFee;
        } else {
            storeServiceFeeValue = 0;
        }
        
        
        // Service Fee - Web Ordering 
        if (serviceFeeWebOrderingValue !== 0 || storeServiceFeeValue !== 0) {
            subTotal =
                <div className="wo-sum__row">
                    <span>Subtotal</span>
                    <span>{`${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.subTotal).toFixed(2)}`}</span>
                </div>
            subTotalBottomPadding = <div className="mb-3"></div>
                // Service Fee - Web Ordering
                if (serviceFeeWebOrderingValue !== 0) {
                    webProcessingFee =
                        <div className="wo-sum__row">
                            <span>{props.cartDetails.cartDetails.serviceFeeWebOrderingMediaName}</span>
                            <span>{`${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.serviceFeeWebOrdering).toFixed(2)}`}</span>
                        </div>
                } else {
                    webProcessingFee = <></>;
                }

                // Delivery + Store Fee - Web Ordering
                if (storeServiceFeeValue !== 0) {
                    deliveryAndServiceFee =
                        <div className="wo-sum__row">
                            <span>Delivery + Service Fee</span>
                            <span>{`${CommonUtilities.StaticFields.CurrencySymbol}${(props.cartDetails.cartDetails.storeServiceFee).toFixed(2)}`}</span>
                        </div>
                } else {
                    deliveryAndServiceFee = <></>;
                }
        } else {
            subTotal = <></>;
            subTotalBottomPadding = <></>;
        }
    }

    // === Store Hours ===
    // Today's Day
    const d = new Date();
    let dayIndex = d.getDay();
    //let dayIndex = 1; // Test different days

    let storeHoursWeekOriginalData = 
    [
        {
            DayIndex: 0,
            DayName: "Sunday",
            OpenTime: props.currentLocation.SundayOpenTime ? moment(props.currentLocation.SundayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.SundayCloseTime ? moment(props.currentLocation.SundayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 1,
            DayName: "Monday",
            OpenTime: props.currentLocation.MondayOpenTime ? moment(props.currentLocation.MondayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.MondayCloseTime ? moment(props.currentLocation.MondayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 2,
            DayName: "Tuesday",
            OpenTime: props.currentLocation.TuesdayOpenTime ? moment(props.currentLocation.TuesdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.TuesdayCloseTime ? moment(props.currentLocation.TuesdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 3,
            DayName: "Wednesday",
            OpenTime: props.currentLocation.WednesdayOpenTime ? moment(props.currentLocation.WednesdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.WednesdayCloseTime ? moment(props.currentLocation.WednesdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 4,
            DayName: "Thursday",
            OpenTime: props.currentLocation.ThursdayOpenTime ? moment(props.currentLocation.ThursdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.ThursdayCloseTime ? moment(props.currentLocation.ThursdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 5,
            DayName: "Friday",
            OpenTime: props.currentLocation.FridayOpenTime ? moment(props.currentLocation.FridayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.FridayCloseTime ? moment(props.currentLocation.FridayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        },
        {
            DayIndex: 6,
            DayName: "Saturday",
            OpenTime: props.currentLocation.SaturdayOpenTime ? moment(props.currentLocation.SaturdayOpenTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null,
            CloseTime: props.currentLocation.SaturdayCloseTime ? moment(props.currentLocation.SaturdayCloseTime, "YYYY-MM-DD HH:mm:ss").format("h:mma") : null
        }
    ]

    let todayHours = storeHoursWeekOriginalData[dayIndex];
    let firstHalfWeek = [];
    let secondHalfWeek = [];
    let todayDisplayHours = todayHours.OpenTime || todayHours.CloseTime ? `${todayHours.OpenTime} - ${todayHours.CloseTime}` : "Closed";

    if (dayIndex < 6) {
        firstHalfWeek = storeHoursWeekOriginalData.slice(dayIndex + 1);
    } 
    if (dayIndex > 0) {
        secondHalfWeek = storeHoursWeekOriginalData.slice(0, dayIndex);
    }
    let weekHoursDataToShow = [...firstHalfWeek, ...secondHalfWeek];
    let weekDisplayHours = weekHoursDataToShow.map((item) => {
        let itemDisplayHours = item.OpenTime || item.CloseTime ? `${item.OpenTime} - ${item.CloseTime}` : "Closed";
        return (
            <tr key={item.DayIndex}>
                <td className="ps-sm-5 pe-sm-4 px-2">{item.DayName}</td>
                <td>{itemDisplayHours}</td>
            </tr>
        )
    });

    // (calError / calInvalidFeedbackClass removed with the datepicker text field —
    //  PickupScheduler renders its own error state from CalendarHasError, which is
    //  passed to it as errorMessage. The same validation flag still drives it.)
    // === Show Pickup Time / Calendar ===
    
    // ---------- Function - Cart: Filter Days ----------
    const isOpenDay = (date) => {
        const day = getDay(date);
        let sunCheck, monCheck, tuesCheck, wedCheck, thurCheck, friCheck, satCheck;
        if (props.currentLocation.SundayOpenTime !== null && props.currentLocation.SundayCloseTime !== null && props.currentLocation.SundayOpenTime !== "Invalid date" && props.currentLocation.SundayCloseTime !== "Invalid date") {
            sunCheck = day === 0;
        } 
        if (props.currentLocation.MondayOpenTime !== null && props.currentLocation.MondayCloseTime !== null && props.currentLocation.MondayOpenTime !== "Invalid date" && props.currentLocation.MondayCloseTime !== "Invalid date") {
            monCheck = day == 1;
        }
        if (props.currentLocation.TuesdayOpenTime !== null && props.currentLocation.TuesdayCloseTime !== null && props.currentLocation.TuesdayOpenTime !== "Invalid date" && props.currentLocation.TuesdayCloseTime !== "Invalid date") {
            tuesCheck = day == 2;
        }
        if (props.currentLocation.WednesdayOpenTime !== null && props.currentLocation.WednesdayCloseTime !== null && props.currentLocation.WednesdayOpenTime !== "Invalid date" && props.currentLocation.WednesdayCloseTime !== "Invalid date") {
            wedCheck = day == 3;
        }
        if (props.currentLocation.ThursdayOpenTime !== null && props.currentLocation.ThursdayCloseTime !== null && props.currentLocation.ThursdayOpenTime !== "Invalid date" && props.currentLocation.ThursdayCloseTime !== "Invalid date") {
            thurCheck = day == 4;
        }
        if (props.currentLocation.FridayOpenTime !== null && props.currentLocation.FridayCloseTime !== null && props.currentLocation.FridayOpenTime !== "Invalid date" && props.currentLocation.FridayCloseTime !== "Invalid date") {
            friCheck = day == 5;
        }
        if (props.currentLocation.SaturdayOpenTime !== null && props.currentLocation.SaturdayCloseTime !== null && props.currentLocation.SaturdayOpenTime !== "Invalid date" && props.currentLocation.SaturdayCloseTime !== "Invalid date") {
            satCheck = day == 6;
        }
        return sunCheck || monCheck || tuesCheck || wedCheck || thurCheck || friCheck || satCheck;
    };

    /* ---------- Function - Cart: Filter Times ----------
       ⚠ The per-day open/close logic below is UNCHANGED, including the
       OffsetStartTimeByMinutes shift applied to every day's start. The only
       edit is the optional dayOverride argument: the pick-up scheduler needs to
       ask "what times are available on Thursday?" before Thursday has been
       committed to CalendarValue. Called with one argument it behaves exactly
       as before. */
    const filteredTimes = (time, dayOverride) => {
        let offsetStartTime = CommonUtilities.StaticFields.OffsetStartTimeByMinutes == '' || CommonUtilities.StaticFields.OffsetStartTimeByMinutes == null ? 0 : CommonUtilities.StaticFields.OffsetStartTimeByMinutes;
        let selectedDay = dayOverride || props.currentLocation.CalendarValue;
        if (selectedDay == '' || selectedDay == null) {
            return
        }
        const dayOfWeek = selectedDay.getDay();
        if (dayOfWeek === 0) { // Sunday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.SundayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.SundayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.SundayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.SundayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 1) { // Monday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.MondayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.MondayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.MondayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.MondayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 2) { // Tuesday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.TuesdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.TuesdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.TuesdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.TuesdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 3) { // Wednesday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.WednesdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.WednesdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.WednesdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.WednesdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 4) { // Thursday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.ThursdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.ThursdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.ThursdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.ThursdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 5) { // Friday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.FridayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.FridayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.FridayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.FridayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        } else if (dayOfWeek === 6) { // Saturday
            const minutes = time.getHours() * 60 + time.getMinutes();
            const hourMin = moment(props.currentLocation.SaturdayOpenTime, 'HH:mm').format('H');
            const minuteMin = moment(props.currentLocation.SaturdayOpenTime, 'HH:mm').format('m');
            const hourMax = moment(props.currentLocation.SaturdayCloseTime, 'HH:mm').format('H');
            const minuteMax = moment(props.currentLocation.SaturdayCloseTime, 'HH:mm').format('m');
            const start = (hourMin * 60) + Number(minuteMin) + offsetStartTime;
            const end = hourMax * 60 + Number(minuteMax);
            return minutes >= start && minutes <= end;
        }
    }

    let pickupTimeOrCalendar = CommonUtilities.StaticFields.ShowCalendar ?
        /* Day chips + time slots, in place of the react-datepicker text field.
           The same two rules decide what is offered — isOpenDay and
           filteredTimes — and handleCalendarChange still receives a Date, so
           nothing downstream of this changes.

           ⚠ minDays carries getCutoffDayOffset() exactly as the datepicker's
           minDate did. That is the catering next-day cutoff: past the cutoff
           time the earliest offered day rolls forward one. Dropping it would
           quietly offer today after the kitchen had stopped taking today's
           orders. The original pickup-lead-time line, commented out on
           2026-10-01 because the customer did not want the feature, is kept
           below so it is not rediscovered as a missing feature:
             // minDays={props.getEarliestPickupDays()} */
        <div className="pt-sm-2 pt-3">
            <PickupScheduler
                value={props.currentLocation.CalendarValue}
                onChange={props.handleCalendarChange}
                isOpenDay={isOpenDay}
                filteredTimes={filteredTimes}
                minDays={(Number(props.currentLocation.CalendarConfig.CalendarMinDays) || 0) + props.getCutoffDayOffset()}
                maxDays={props.currentLocation.CalendarConfig.CalendarMaxDays}
                disabled={props.cartError.ButtonsDisabled}
                errorMessage={props.currentLocation.Validation.CalendarHasError
                    ? props.currentLocation.Validation.CalendarErrorMessage : ''}
            />
            {props.getCutoffDayOffset() === 1 &&
                <div className="alert alert-warning py-2 px-3 small mt-2 mb-0" role="alert">{Messages.CateringCutoffPassed(CommonUtilities.StaticFields.CateringNextDayCutoffTime)}</div>
            }
        </div>
        :
        // Pickup time
        <InputGroup className="col-6 mt-3">
            <InputGroup.Text className="rounded-start-pill px-sm-4">
                Pick up
            </InputGroup.Text>
            <Form.Select className="text-center rounded-end-pill" value={props.currentLocation.PickupTimeValue} onChange={props.handlePickupTimeChange} disabled={props.cartError.ButtonsDisabled}>
                {pickupTimeOptions}
            </Form.Select>
        </InputGroup> 

    return (
        <>
            <CartNavigation
                cartError={props.cartError}
                handleBackClickCart={props.handleBackClickCart}
            />
            <div className="wo-cartWrap">
              <div className="wo-cartGrid">
                <div className="wo-cartMain">
                {isWebOrder && props.pickupOrDelivery.SwitchMenuNav.SwitchPickupDeliveryValue === 'pickup' &&
                    <div className="wo-panel">
                        <div className="row">
                            <div className="wo-panel__head col-12">Pickup Location</div>
                            <div className="col-sm-8 col-md-7 col-lg-6 col-xl-4">
                                {props.currentLocation.LocationName && <><b>{props.currentLocation.LocationName}</b><br /></>}
                                {props.currentLocation.LocationAddressLine1 && <><span>{props.currentLocation.LocationAddressLine1}</span><br /></>}
                                {props.currentLocation.LocationAddressLine2 && <><span>{props.currentLocation.LocationAddressLine2}</span><br /></>}
                                <span>{props?.currentLocation?.LocationSuburb} {props?.currentLocation?.LocationState} {props?.currentLocation?.LocationPostcode}</span><br />

                                {/* === Store Hours - TO DO > Uncomment when backend ready === */}
                                {/* <div id="accordionStoreHours" className="accordion my-2">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header">
                                        <button type="button" className="accordion-button collapsed p-2" type="button" data-bs-toggle="collapse" data-bs-target="#collapseStoreHours" aria-expanded="false" aria-controls="collapseStoreHours">
                                            <small className="fw-medium">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="pe-sm-1">Hours</td>
                                                            <td className="ps-sm-3 pe-sm-5 px-2">{todayHours.DayName}</td>
                                                            <td>{todayDisplayHours}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </small>
                                        </button>
                                        </h2>
                                        <div id="collapseStoreHours" className="accordion-collapse collapse" data-bs-parent="#accordionStoreHours">
                                            <div className="accordion-body">
                                                <small>
                                                    <table>
                                                        <tbody>
                                                            {weekDisplayHours}
                                                        </tbody>
                                                    </table>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-sm-4 col-md-5 col-lg-6 col-xl-8 text-sm-end text-start">{props.currentLocation.LocationDistance !== "" && `${props.currentLocation.LocationDistance}kms`}</div>
                            { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                            /* Left-aligned under the address rather than centred
                               in the card — the two belong to the same thought.
                               minWidth:0 so the day chips can shrink instead of
                               forcing the grid wider. */
                            <div className="col-12 p-0 m-0" style={{minWidth: 0}}>
                                {pickupTimeOrCalendar}
                            </div> }
                        </div>
                    </div>
                }
                <div className="wo-panel">
                    <div className="row">
                        <div className="wo-panel__head col-12">Your Order</div>
                        {products}
                        {voucher}
                        {/* 2026-10-14 Voucher code. Behind the same gate as the notes (a store not
                            taking orders shows neither), only when the brand switched it on in S8MC
                            Website Config, and never while a voucher is already applied - one per
                            cart. The server enforces all three as well. */}
                        { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber
                          && props.showVoucherCodeEntry && !hasVoucher &&
                        <div className="col-12 wo-vcode">
                            {!props.voucherCode?.Open
                                ? <button type="button" className="wo-vcode__link" onClick={props.handleVoucherCodeOpen}>{Messages.VoucherCodePrompt}</button>
                                : <form className="wo-vcode__form" onSubmit={props.handleApplyVoucherCode} noValidate>
                                    <label htmlFor="txtVoucherCode" className="visually-hidden">{Messages.VoucherCodeLabel}</label>
                                    <div className="wo-vcode__row">
                                        <input type="text" id="txtVoucherCode" name="txtVoucherCode"
                                               className={props.voucherCode.Error ? "form-control is-invalid" : "form-control"}
                                               value={props.voucherCode.Code} onChange={props.handleVoucherCodeChange}
                                               maxLength="50" autoComplete="off" autoCapitalize="characters" spellCheck={false}
                                               autoFocus aria-describedby="txtVoucherCodeError" />
                                        <button type="submit" className="wo-vcode__apply" disabled={props.voucherCode.Busy}>
                                            {props.voucherCode.Busy
                                                ? <Spinner animation="border" role="status" size="sm"><span className="visually-hidden">Applying</span></Spinner>
                                                : Messages.VoucherCodeApply}
                                        </button>
                                    </div>
                                    {props.voucherCode.Error &&
                                        <div id="txtVoucherCodeError" className="wo-vcode__error" role="alert">{props.voucherCode.Error}</div>}
                                  </form>}
                        </div> }
                        { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                        <div className="col-12 row p-0 m-0">
                            <div className={CommonUtilities.StaticFields.HideKitchenNotes ? "form-floating d-none" : "form-floating"}>
                                <textarea className={props.orderPayBody.validation.RestaurantInstructions.HasError ? "form-control is-invalid" : "form-control"} name="txtareaOrderNotes" placeholder="Any notes for your order?" style={{height: "100px"}} value={props.orderPayBody.data.OrderNote} onChange={props.handleCartNotes} maxLength="300"></textarea>
                                <label style={{marginLeft: "12px"}}>Any notes for your order?</label>
                                <small className="invalid-feedback">{props.orderPayBody.validation.RestaurantInstructions.ErrorMessage}</small>
                            </div>
                        </div> }
                    </div>
                </div>
                </div>

                {/* ⚠ THIS GATE IS LOAD-BEARING AND MUST NOT BE RELAXED.
                    AllowOnlineOrder && IsValidTableNumber decides whether the
                    customer can check out at all. When it is false there is
                    deliberately NO total and NO Order & Pay button — a store
                    that is not accepting orders, or an invalid table, must not
                    be payable. The same gate guards the pickup time and the
                    kitchen instructions above. */}
                { props.currentLocation.AllowOnlineOrder && props.currentLocation.Validation.IsValidTableNumber &&
                <aside className="wo-sum">
                    <div className="wo-sum__panel">
                        <div className="wo-sum__title">Summary</div>
                        {subTotal}
                        {voucherSummaryRow}
                        {deliveryAndServiceFee}
                        {webProcessingFee}
                        {subTotalBottomPadding}
                        <div className="wo-sum__row wo-sum__row--total">
                            <span>Total</span>
                            <span>{totalPrice}</span>
                        </div>
                        <button type="button" className="wo-sum__pay" onClick={props.handleValidateCart}>
                            Order &amp; Pay
                        </button>
                        <p className="wo-sum__legal">
                            All prices are in AUD and include GST<br />
                            Order enquires and refunds will be handled by the merchant
                        </p>
                        {props.cartError.HasError && <div className="mt-3"><ErrorAlert message={props.cartError.Message} /></div>}
                    </div>
                </aside>}
              </div>

              <div className="wo-poweredBy">
                <a href="https://www.shift8.com/" target="_blank" rel="noreferrer">
                    <svg role="img" width="80px" height="28px" aria-labelledby="Powered by Shift8">
                        <title>Powered by Shift8</title>
                        <S8PoweredByLogo />
                    </svg>
                </a>
              </div>
            </div>
            <CustomerDetailsModal
                showCustomerDetailsModal={props.showCustomerDetailsModal} 
                customerDetailsFormData={props.customerDetailsFormData}
                handleCloseCustomerDetailsModal={props.handleCloseCustomerDetailsModal}
                handleChangeCustDetails={props.handleChangeCustDetails}
                handleSubmitCustDetails={props.handleSubmitCustDetails}
                urlConfig={props.urlConfig}
                // --- Pickup / Delivery ---
                pickupOrDelivery={props.pickupOrDelivery}
                // --- Loyalty ---
                loyaltyIsLoggedIn={props.loyaltyIsLoggedIn} // Part of loyaltyMember State
            />
            <ErrorModal 
                errorModal={props.errorModal}
                handleCloseErrorModal={props.handleCloseErrorModal}
            />
            <OfflineModal
                offlineModal={props.offlineModal}
                handleCloseOfflineModal={props.handleCloseOfflineModal}
                urlConfig={props.urlConfig}
            />
        </>
    )
}